import {Component, OnInit} from '@angular/core';
import {DataService} from 'projects/paid/src/app/components/publications/data.service';
import {TranslateService} from '@ngx-translate/core';
import {NavigationEnd, Router} from '@angular/router';
import {NavigationEvent} from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';
import {filter} from 'rxjs';

@Component({
    selector: 'app-publications',
    templateUrl: './publications.component.html',
    styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {
    loading = true;
    postsTr = {};

    constructor(
        private service: DataService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.translate.onLangChange.subscribe((e: any) => {
            if (!this.postsTr[this.translate.currentLang]) {
                this.getData();
            }
        });
    }

    getData() {
        this.service.fetchData()
            .subscribe((res: any[]) => {
                this.postsTr[this.translate.currentLang] = res;
                this.loading = false;
            }, () => {
                this.loading = false;
            });
    }

    get showBlock() {
        return this.postsTr[this.translate.currentLang]?.length && !this.loading;
    }

    findElementByHeaderPosition(position: number) {
        return this.postsTr[this.translate.currentLang].find(el => el.position === position.toString());
    }
}
